import { Pipe, PipeTransform } from "@angular/core";
import { AccountService } from "@modules/account/services/account.service";
import { Conversion, Fiat } from "@models";
import { convertTradableToFiat } from "@helpers/tradable-convert";
import { TradableListService } from "@main-services/currency/tradable_list.service";
import { stripFunnyInput } from "@helpers/utils";
import { IFiatToTradableConversionOptions } from "./fiat-to-tradable.pipe";

@Pipe({
	name: "convert_tradable_to_fiat",
	standalone: false
})
export class ConvertTradableToFiatPipe implements PipeTransform {
	public constructor(
		private accountService: AccountService,
		private tradableListService: TradableListService
	) {}

	private get defaultFiat(): Fiat {
		return this.accountService.getDefaultFiat();
	}

	public transform(value: string | number, id: string): number {
		value = stripFunnyInput(value);
		return convertTradableToFiat(this.tradableListService.getItemById(id), +value, this.defaultFiat);
	}
}

@Pipe({
	name: "convert_tradable_to_fiat_dynamic",
	standalone: false
})
export class ConvertTradableToFiatDynamicPipe implements PipeTransform {
	public constructor(private tradableListService: TradableListService) {}

	public transform(value: string | number, options: { id: string; fiat: Fiat }): number {
		if (!value) {
			return 0;
		}
		value = stripFunnyInput(value);
		return convertTradableToFiat(this.tradableListService.getItemById(options?.id), +value, options.fiat);
	}
}

@Pipe({
	name: "convert_tradable_to_fiat_conversion",
	standalone: false
})
export class ConvertTradableToFiatConversionPipe implements PipeTransform {
	private conversion = new Conversion();

	public transform(value: string | number, options: IFiatToTradableConversionOptions): number {
		if (!value) {
			return 0;
		}
		value = stripFunnyInput(value);
		this.conversion.setFiatAmount(options.price.getPrice().getFiat());
		return convertTradableToFiat(this.conversion, +value, options.fiat);
	}
}
